import { Link, useNavigate } from 'react-router-dom';
import { FiShoppingCart, FiUser } from 'react-icons/fi';

const Header = ({ cartCount }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem('admin_token');

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    navigate('/');
  };

  return (
    <header className="glass-header sticky top-0 z-50 shadow-sm" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" data-testid="logo-link">
            <h1 className="brand-logo text-4xl sm:text-5xl" data-testid="brand-logo">Mango Cosmetics</h1>
          </Link>
          
          <nav className="flex items-center gap-6">
            <Link 
              to="/products" 
              className="text-[#3A1C00] font-['Fredoka'] font-bold hover:text-[#FFB800] transition-colors"
              data-testid="nav-products-link"
            >
              Products
            </Link>
            
            <Link 
              to="/cart" 
              className="relative text-[#3A1C00] hover:text-[#FFB800] transition-colors"
              data-testid="nav-cart-link"
            >
              <FiShoppingCart size={24} />
              {cartCount > 0 && (
                <span 
                  className="absolute -top-2 -right-2 bg-[#FF6B9E] text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center"
                  data-testid="cart-count-badge"
                >
                  {cartCount}
                </span>
              )}
            </Link>

            {token ? (
              <div className="flex items-center gap-4">
                <Link 
                  to="/admin/dashboard" 
                  className="text-[#3A1C00] hover:text-[#FFB800] transition-colors"
                  data-testid="nav-admin-dashboard-link"
                >
                  <FiUser size={24} />
                </Link>
                <button 
                  onClick={handleLogout}
                  className="text-sm text-[#FF6B9E] font-bold hover:text-[#FF4785] transition-colors"
                  data-testid="logout-button"
                >
                  Logout
                </button>
              </div>
            ) : (
              <Link 
                to="/admin/login" 
                className="text-[#3A1C00] hover:text-[#FFB800] transition-colors"
                data-testid="nav-admin-login-link"
              >
                <FiUser size={24} />
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;